<template>
  <div class="shape">
    <svg fill="none"  class="waves" xmlns="http://www.w3.org/2000/svg"
         xmlns:xlink="http://www.w3.org/1999/xlink"
         viewBox="0 24 150 28" preserveAspectRatio="none" shape-rendering="auto">
      <path id="gentle-wave" d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"/>
      <g class="parallax">
        <use xlink:href="#gentle-wave" x="48" y="-2" fill="#98ada2"/><!--purple-->
        <use xlink:href="#gentle-wave" x="48" y="1" fill="#a5b09c"/><!--red-->
        <use xlink:href="#gentle-wave" x="48" y="1" fill="#69A653"/><!--yellow-->

      </g>

    </svg>
  </div>
</template>

<script>
import {} from "@ionic/vue";

export default {
  components: {},
  data() {
    return {
      isDesktop: null,
    }
  },
  computed: {},
  methods: {},
  async created() {
  }
};
</script>
<style lang="scss">
.waves {
  position: relative;
  width: 100%;
  height: 20vh;
  margin-bottom: -7px; /*Fix for safari gap*/
  min-height: 80px;
  max-height: 80px;
}


/* Animation */

.parallax > use {
  animation: move-forever 25s cubic-bezier(.55, .5, .45, .5) infinite;
}

.parallax > use:nth-child(1) {
  animation-delay: -2s;
  animation-duration: 10s;
}

.parallax > use:nth-child(2) {
  animation-delay: -3s;
  animation-duration: 7s;
}

.parallax > use:nth-child(3) {
  animation-delay: -4s;
  animation-duration: 13s;
}

.parallax > use:nth-child(4) {
  animation-delay: -5s;
  animation-duration: 20s;
}

@keyframes move-forever {
  0% {
    transform: translate3d(-90px, 0, 0);
  }
  100% {
    transform: translate3d(85px, 0, 0);
  }
}

/*Shrinking for mobile*/
@media (max-width: 768px) {
  .waves {
    height: 80px;
    min-height: 40px;
  }
}


.shape {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  overflow: hidden;
  background: #ffffffcc;
  line-height: 0;
}

.shape svg {
  position: relative;
  display: block;
  width: 100%;
  height: auto;
}
</style>
